import React, { useState } from "react";
import {
  FaEye,
  FaEyeSlash,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";

// import pic1 from "../images/pic1.png"; // Import the image

function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const passwordClasses = ["form-group", "col-12", "fg1"];
  if (showPassword) {
    passwordClasses.push("show-password");
  }

  return (
      <div className="containerL p-5 text-center ">
        <h3 className="text-white text-center mb-4">LOGIN</h3>
        <form>
          <div className="form-group fg1">
            <input
              type="email"
              className="form-control mb-2"
              id="username"
              placeholder="Enter your username"
              required
            />
          </div>
          <div className={passwordClasses.join(" ")}>
            <div className="col-12 d-flex">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control mb-2"
                id="password"
                placeholder="Enter your password"
                required
              />
              <FaEye
                className={`mt-2 mx-2 text-white ${
                  showPassword ? "show-eye" : ""
                }`}
                onClick={togglePasswordVisibility}
              />
            </div>
          </div>
          <div className="form-group">
            <a href="/forgotPassword" className="btn btn-link forget ">
              Forgot Password?
            </a>
          </div>
          <button type="submit" className="btn btn-primary btn-login mx-auto">
            Sign In
          </button>

          <div className="form-group nr col-12 d-flex mb-0 mt-3">
            <p className="col-7">
              Not registered?
              <a href="#" className="btn btn-link signup">
                SIGNUP
              </a>
            </p>
          </div>
          <div className="form-group m-0">
            <a href="/" className="btn btn-link forget2 m-0">
              Back to home page
            </a>
          </div>
          <FaFacebook className="fa-lg text-white mx-2 m-2" style={{ fontSize: '1.5em' }} />
          <FaInstagram className="fa-lg text-white mx-2 m-2" style={{ fontSize: '1.5em' }}/>
          <FaLinkedin className="fa-lg text-white mx-2 m-2" style={{ fontSize: '1.5em' }}/>
        </form>
      </div>
  );
}

export default LoginForm;
